import catalogContexts from "@utils/constants/catalogContexts";
import algoliaIndices from "@utils/constants/algoliaIndices";

const { mainIndexV1, mainIndexV2, baseSalesIndex } = algoliaIndices;

export default function computeSortBy(context, sortBy, isUserC1, catalogVersion) {
  if (catalogVersion === 1) {
    switch (context) {
      case catalogContexts.swap:
        if (!sortBy || ["our_choice", "discovery"].includes(sortBy)) {
          if (isUserC1) return `${mainIndexV1}-discovery`;

          return mainIndexV1;
        }

        return `${mainIndexV1}-${sortBy}`;
      case catalogContexts.wishlist:
      case catalogContexts.userlist:
        if (!sortBy) return `${mainIndexV1}-newest`;

        if (["our_choice", "discovery"].includes(sortBy)) {
          if (isUserC1) return `${mainIndexV1}-discovery`;

          return mainIndexV1;
        }

        return `${mainIndexV1}-${sortBy}`;
      case catalogContexts.sales:
        if (!sortBy || sortBy === "our_choice") return baseSalesIndex;

        return `${baseSalesIndex}-${sortBy}`;
      default:
        return mainIndexV1;
    }
  } else {
    switch (context) {
      case catalogContexts.swap:
        if (!sortBy || ["our_choice", "discovery"].includes(sortBy)) return mainIndexV2;

        return mainIndexV2.replace("principal", sortBy);
      case catalogContexts.wishlist:
      case catalogContexts.userlist:
        if (!sortBy || sortBy === "newest") return mainIndexV2.replace("principal", "newest");

        return mainIndexV2;
      case catalogContexts.sales:
        if (!sortBy || sortBy === "our_choice") return mainIndexV2.replace("principal", "sale");

        return mainIndexV2.replace("principal", sortBy);
      default:
        return mainIndexV2;
    }
  }
}
